import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { FormGroup } from '@bingads-webui-cc-react/layout';
import TextModel from './text-model';
import type { LinkModel, NoticeTextModelProps } from './types';

const NoticeTextModelUnwrapped = ({
  i18n
}: NoticeTextModelProps) => {
  const NoticeRichText = useMemo<LinkModel[]>(
    () => [{
      Uri: 'https://go.microsoft.com/fwlink/?LinkId=521839',
      TextItems: [i18n.getString('SignUpAgreementPrivacyStatementText')],
      Type: 'LinkModel',
    }],
    [i18n]
  );

  return (
    <FormGroup id="notice-string-for-notice-country" contentColClass="col-sm-12" showLabel={false} isStatic >
      <TextModel
        i18n={i18n}
        localizationKey="SignUp_Agreements_For_Notice_Country"
        richTextItems={NoticeRichText}
      />
    </FormGroup>
  );
};
NoticeTextModelUnwrapped.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
NoticeTextModelUnwrapped.displayName = 'NoticeTextModel';
export default memo(NoticeTextModelUnwrapped);
